export default __webpack_public_path__ + "static/media/wifi-1.15413a74.png";